import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Error from "../base-component/Error/Error";
import { privateRouters, publicRouters, liveURL } from "../router/allRoutes";
import MainLayout from "../layout/MainLayout/MainLayout";
import PrivateRoute from "./privateRoute";
import PublicRoute from "./publicRoute";
import ScrollToTop from "../base-component/ScrollToTop/ScrollToTop";

function RouterData() {
  return (
    <BrowserRouter basename={liveURL}>
      <ScrollToTop />
      <Routes>
        <Route path="*" element={<Error />} />

        {publicRouters.map((item, index) => (
          <Route
            key={index}
            path={item.path}
            element={<PublicRoute>{item.element}</PublicRoute>}
          />
        ))}

        {privateRouters.map((item, index) => (
          <Route
            key={index}
            path={item.path}
            element={
              <PrivateRoute>
                <MainLayout>{item.element}</MainLayout>
              </PrivateRoute>
            }
          />
        ))}
      </Routes>
    </BrowserRouter>
  );
}

export default RouterData;
